import { applyFilters, doRequest } from "./helpers";
import { isCustomTable } from "./customTableType";
import useAuthStore from "../stores/useAuthStore";

const activityPaths = {
  Campaign: "/campaign/activity",
  Contact: "/contact/activity",
  Entity: "/entity/activity",
  CampaignTarget: "/campaign/target/activity",
  Case: "/case/activity",
  RevenueOpportunity: "/revenue_opportunity/activity",
};

export default class ActivityService {
  static buildActivityPath(modelType, { slug, modelId } = {}) {
    if (isCustomTable(modelType)) {
      return `/custom_tables/${slug}/rows/${modelId}/activity`;
    }
    if (modelId != null) {
      return `${activityPaths[modelType]}/${modelId}`;
    }
    return activityPaths[modelType];
  }

  static async getCategories() {
    return doRequest("GET", "/activity/category/");
  }

  static async createCategory(name) {
    return doRequest("POST", "/activity/category/", { data: { name } });
  }

  static async editCategory(id, data) {
    return doRequest("PUT", `/activity/category/${id}`, { data });
  }

  static async deleteCategory(id) {
    return doRequest("DELETE", `/activity/category/${id}`);
  }

  static async getActivityLogs(modelId, modelType, filters = null, opts = {}) {
    const path = applyFilters(
      filters,
      ActivityService.buildActivityPath(modelType, { ...opts, modelId })
    );
    return doRequest("GET", path);
  }

  static async getActivityLog(modelType, logId, opts = {}) {
    const base = isCustomTable(modelType)
      ? ActivityService.buildActivityPath(modelType, opts)
      : activityPaths[modelType];
    return doRequest("GET", `${base}/log/${logId}`);
  }

  static async createActivityLog(data, opts = {}) {
    const path = ActivityService.buildActivityPath(data.model_type, opts);
    return doRequest("POST", path, { data });
  }

  static async hasNotes(modelId, modelType, opts = {}) {
    let path;
    if (isCustomTable(modelType)) {
      path = `${ActivityService.buildActivityPath(modelType, { ...opts, modelId })}/has_notes`;
    } else {
      path = `${activityPaths[modelType]}/has_notes/${modelId}`;
    }
    return doRequest("GET", path);
  }

  static async createActivityLogForImport(campaignId, attachments) {
    const data = {
      model_id: campaignId,
      model_type: "Campaign",
      info: {
        comment: "Attached file was used for importing",
        is_import: true,
      },
      creator_user_id: useAuthStore.getState().userAuth.id,
      attachments: attachments,
    };
    return doRequest("POST", "/activity/", { data });
  }

  static async createActivityLogForAuditLogImport(campaignId, attachments) {
    const data = {
      model_id: campaignId,
      model_type: "Campaign",
      info: {
        comment: "Attached file is being used for importing audit logs",
        is_audit_log_import: true,
      },
      creator_user_id: useAuthStore.getState().userAuth.id,
      attachments: attachments,
    };
    return doRequest("POST", "/activity/", { data });
  }

  static async updateActivityLog(logId, data, opts = {}) {
    const base = isCustomTable(data.model_type)
      ? ActivityService.buildActivityPath(data.model_type, opts)
      : activityPaths[data.model_type];
    return doRequest("PUT", `${base}/log/${logId}`, { data });
  }

  static async deleteActivityLog(modelType, logId, opts = {}) {
    const base = isCustomTable(modelType)
      ? ActivityService.buildActivityPath(modelType, opts)
      : activityPaths[modelType];
    return doRequest("DELETE", `${base}/log/${logId}`);
  }

  static async search(query) {
    return doRequest("GET", `/activity/search/${query}`);
  }
}
